import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { LoadingIndicator } from 'common/components/preloader';

/**
 * Enable Payoneer account.
 * This screen should be reached as a result of a creative completing the Payoneer
 * registration process.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class EnablePayoneer extends Component {
  componentDidMount() {
    this.props.enable();
  }

  render() {
    const { enabled } = this.props;

    return (
      <div className="l-content info-screen" id="content">
        {enabled === undefined?
        <LoadingIndicator/>:
        <div className="row">
          <div className="columns medium-8 small-16">

            <h2>
              {enabled? 'Payoneer Account Enabled':'Failed to Enable Payoneer Account'}
            </h2>

            {enabled?
            <p>
              You Payoneer account is now enabled. You can now close this tab.
            </p>:
            <p>
              We weren't able to enable your Payonner account. Please get in touch with
              customer service.
            </p>}

            { !enabled &&
            <Link className="btn btn-primary" to="/help/contact/">Get in Touch</Link> }
          </div>

          <div className="columns medium-8 small-16 icon hide-for-small-only">
            <i className={"fa fa-" + (enabled? "check-circle":"frown-o")}></i>
          </div>
        </div>}

      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {func} enable - enable Payoneer account
 * @property {bool} enabled - whether Payoneer account is enabled
 */
EnablePayoneer.propTypes = {
  enable: PropTypes.func,
  enabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./account/components/payout/enable_payoneer.jsx